const hasProp = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);

export function propertyExists(obj, prop) {
  return (
    typeof obj === "object" &&
    obj !== null &&
    hasProp(obj, prop)
  )
}

export function getExistingKey(obj, props) {
  let keys = Array.isArray(props) ? props : [props];
  if (typeof obj === "object" && obj !== null) {
    return keys.find((k) => hasProp(obj, k));
  }
  return null;
}

/**
 * Get the value of an object by using the first key present in the object from an array of keys. If no keys exist
 * in the object, than the object itself is returned.
 * @param obj
 * @param props
 */
export function getValueByKeys(obj, props) {
  let keys = Array.isArray(props) ? props : [props];
  if (typeof obj !== "object" || !obj) {
    return null;
  }
  const key = keys.find((k) => hasProp(obj, k));
  return key ? obj[key] : obj;
}
